import { Component, OnDestroy, OnInit } from '@angular/core';
import { catchError, EMPTY, exhaustMap, interval, Subject, tap } from 'rxjs';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-live',
  templateUrl: './live.component.html',
  styleUrl: './live.component.scss',
})
export class LiveComponent implements OnInit, OnDestroy {
  fetchSubscription; // 60 seconds

  refreshTime = 10000; // 10 seconds

  circularProgressStart = new Subject<void>();

  constructor(protected analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.circularProgressStart.next();
    // Nur Sitzungen pro Minute: Feed, Gauge und KPIs pollen selbst. Nächster
    // Abruf erst, wenn der letzte zurück ist.
    this.fetchSubscription = interval(this.refreshTime)
      .pipe(
        tap(() => this.circularProgressStart.next()),
        exhaustMap(() =>
          this.analyticsService
            .getRealTimeSessionsPerMinute()
            .pipe(catchError(() => EMPTY))
        )
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.fetchSubscription?.unsubscribe();
  }
}
